import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useTranslation } from "../i18n/LanguageContext";

const LOGO_URL = "/logo-sciad.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { lang, setLang, t } = useTranslation();

  const navLinks = [
    { name: t("nav_home"), href: "#home" },
    { name: t("nav_expertise"), href: "#expertise" },
    { name: t("nav_software"), href: "#solutions" },
    { name: t("nav_news"), href: "#actualites" },
    { name: t("nav_contact"), href: "#contact" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20">
          <a href="#home" className="flex items-center gap-3 shrink-0" data-testid="logo-link">
            <img src={LOGO_URL} alt="SCIAD" className="h-10 sm:h-14 w-auto" />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm font-medium text-slate-300 hover:text-white transition-colors relative group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#00CCC2] to-[#2395E3] group-hover:w-full transition-all duration-300" />
              </a>
            ))}
            <button
              onClick={() => setLang(lang === "fr" ? "en" : "fr")}
              className="ml-2 px-3 py-1.5 rounded-lg border border-white/10 text-xs font-bold text-slate-300 hover:text-white hover:border-[#00CCC2] transition-all"
              data-testid="lang-switcher"
            >
              {lang === "fr" ? "EN" : "FR"}
            </button>
          </div>

          <div className="flex items-center gap-3 md:hidden">
            <button
              onClick={() => setLang(lang === "fr" ? "en" : "fr")}
              className="px-2 py-1 rounded-lg border border-white/10 text-xs font-bold text-slate-300"
              data-testid="lang-switcher-mobile"
            >
              {lang === "fr" ? "EN" : "FR"}
            </button>
            <button
              className="p-2 z-10 text-white"
              onClick={() => setIsOpen(!isOpen)}
              data-testid="mobile-menu-toggle"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden glass border-t border-white/10">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="block text-slate-300 hover:text-white transition-colors"
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
